import { CallsAlertsSearchBarValues } from "../types";
import { cleanFormikValues, QueryValueObj } from "./buildAndCleanQueryString";
import cleanInitialStateFromQuery from "./cleanInitialStateFromQuery";

type CallsAlertsSearchBarKeys = keyof CallsAlertsSearchBarValues;
type Options = {
  removeDashes: CallsAlertsSearchBarKeys[];
  returnAsArray: CallsAlertsSearchBarKeys[];
};

/**
 * @description this function takes a URLSearchParams object and returns
 * a formik compatible object
 * @param urlParams = URLSearchParams
 * @param options =  string arrays of keys to remove dashes from and return as array
 * @returns a formik compatible object
 */
export const formatUrlParamsToFormik = (
  urlParams: URLSearchParams,
  options: Options
) => {
  const cleanedDashes = cleanInitialStateFromQuery(
    Object.fromEntries(urlParams),
    options.removeDashes as unknown as string[]
  );

  const cleanedWithArrays = getArrayAsValue(
    cleanedDashes,
    options.returnAsArray
  );

  return cleanFormikValues(cleanedWithArrays, {});
};

/**
 * @description this function accepts an object and a list of keys to convert the corresponding values into arrays
 * @param params formik object
 * @param toArray list of keys to convert to arrays
 * @returns a formik compatible object
 */
function getArrayAsValue(
  params: QueryValueObj,
  toArray: CallsAlertsSearchBarKeys[]
) {
  const result = { ...params };
  toArray.forEach((item: CallsAlertsSearchBarKeys) => {
    if (result[item]) {
      result[item] = String(result[item]).split(",");
    } else {
      return [];
    }
  });
  return result;
}
